import { ProductGalleryV2, ProductGalleryStyleV2Type, SourceTypeEnums } from '@commerce-product-webcomponents/ui';
import { PreviewPanel } from '@nextgen-web-framework/all';
import { useState } from 'react';
import { ContentHeaderCard, CustomerLeadCard } from '@commerce-webcomponents/ui';
import styles from './PromotionOverview.module.scss';

import { type PromotionOverviewProps } from './types/propsTypes';

const PromotionOverview = (props: PromotionOverviewProps) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [galleryId, setGalleryId] = useState<string>('');
  const { tag, description, title, galleryList } = props;
  const onOpenModal = (galleryId: string | number) => {
    setShowModal(true);
    setGalleryId(String(galleryId));
  };
  const onCloseModal = () => {
    setShowModal(false);
    setGalleryId('');
  };

  const renderValidity = () => (
    <div className={styles['validity-container']}>
      <div className={styles['title']}>{props.validityList?.title}</div>
      <div className={styles['validity-item']}>
        {props.validityList?.items.map((item) => (
          <CustomerLeadCard
            key={item.title}
            title={item.title}
            description={item.description}
            tagBackgroundColor={item.tagBackgroundColor}
            tagNameColor={item.tagNameColor}
            tagName={item.tagName}
          />
        ))}
      </div>
    </div>
  );
  return (
    <>
      {showModal && (
        <PreviewPanel onClose={onCloseModal}>
          <ProductGalleryV2
            sourceKey={SourceTypeEnums.MODAL_GALLERY}
            productGalleryStyleType={ProductGalleryStyleV2Type.PRODUCT_GALLERY_MODAL}
            galleryList={galleryList}
            galleryId={galleryId}
          />
        </PreviewPanel>
      )}
      <div
        data-testid={`promotion-overview-container-testid`}
        className={`${styles['content-detail-gallery-container']}`}
      >
        <div className={`${styles['content-detail-gallery']}`}>
          <div className={`${styles['content-detail-gallery-section']}`}>
            <ProductGalleryV2
              galleryId={galleryId}
              openModal={onOpenModal}
              sourceKey={SourceTypeEnums.PRODUCT_DETAIL_GALLERY}
              galleryList={galleryList}
            />
          </div>
          <div className={styles['content-container']}>
            <div className={styles['content-card']}>
              <ContentHeaderCard title={title} description={description} tag={tag} />
            </div>
            {props.validityList?.items && props.validityList?.items.length > 0 && <>{renderValidity()}</>}
          </div>
        </div>
      </div>
    </>
  );
};
export default PromotionOverview;
